import React, { useEffect, useRef, useState } from "react";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import useDeviceType from "../../custom-hooks/DeviceType";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import Button from "../../component-lib/Molecules/button/Button";
import { editPencil } from "../../assets";
import useHasOverflow from "../../custom-hooks/HasOverflow";
import EventEHRProviderProfileDetailCardWithEdit from "../../component-lib/Organisms/provider-profile-detail-card/EventEHRProviderProfileDetailCardWithEdit";
import { TEXT_CONSTANTS } from "../../utils/text-constants/textConstants";
import MenuDropdown from "../../component-lib/Molecules/menuDropdown/MenuDropdown";
import Table from "../../component-lib/Organisms/table/EventEHRTable";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  componentKey,
  setCloseAddUserProfileDialog,
  setcloseEditTaskDialog,
  setCloseChangePasswordDialog,
} from "../provider-profile-screen/providerProfileSlice";
import {
  changePassword,
  getProviderTaskList,
  getUserById,
  updateEditTaskData,
  updateProfileDetailsData,
} from "../provider-profile-screen/providerProfileSaga";
import { setIsLoggedIn } from "../login-screen/LoginSlice";
import ChangePasswordDialog from "./dialogs/ChangePasswordDialog";
import {
  destructStatusData,
  getStatusBackground,
  getStatusDotColor,
  getStatusTextColor,
} from "../../utils/statusConstants";
import ViewTaskDialog from "../tasks-screen/dialogs/ViewTaskDialog";
import {
  getLoginUserData,
  getLoginUserId,
  getUserLoginData,
} from "../../utils/getToken";
import EditTaskDialog from "../tasks-screen/dialogs/EditTaskDialog";
import TooltipForTable from "../../component-lib/Molecules/tooltip/TooltipForTable";

const SettingsScreen = () => {
  const {
    taskListData,
    closeEditTaskDialog,
    userProfileData,
    closeAddUserProfileDialog,
    closeChangePasswordDialog,
  } = useSelector((state: any) => state[componentKey]);

  const parseLoginUserId: any = getLoginUserId();
  const parseLoginUserdata: any = getUserLoginData();

  const myLogin: any = getLoginUserData();
  const Userdata = JSON.parse(myLogin);

  const loginUserId = JSON.parse(parseLoginUserId);
  const loginUserdata = JSON.parse(parseLoginUserdata);

  // Get role from userProfileData or sessionStorage. Guard against the literal
  // "undefined"/"null" strings that can end up in sessionStorage.
  const rawRoleName =
    userProfileData?.role?.name ||
    (sessionStorage.getItem("role")?.replace(/"/g, "") || "");
  const roleName =
    rawRoleName && rawRoleName !== "undefined" && rawRoleName !== "null"
      ? rawRoleName
      : "";

  const dispatch = useDispatch();
  const divRef = useRef<HTMLDivElement>(null);
  const hasOverflow = useHasOverflow(divRef);
  const deviceType = useDeviceType();
  const [openAddTaskDialog, setOpenAddTaskDialog] = useState(false);
  const [openChangePasswordDialog, setOpenChangePasswordDialog] =
    useState(false);
  const [rowPerPage, setRowPerPage] = useState("10");
  const [pageNumber, setPageNumber] = useState(1);
  const [isEditable, setIsEditable] = useState(false);
  const [openViewTaskDialog, setOpenViewTaskDialog] = useState(false);
  const [defaultTaskDataRow, setDefaultTaskDataRow] = useState<any>({});
  const handleIsEdited = () => {
    setIsEditable(!isEditable);
  };
  const [selectedTask, setSelectedTask] = useState();
  const [isPaginationApplied, setIsPaginationApplied] = useState({
    isTrue: false,
    filterData: {},
  });

  //VIEW TASK DIALOGBOX KEYS
  const defaultTaskData = {
    taskType: "",
    assignBy: "",
    assignTo: "",
    assignedDate: "",
    dueDate: "",
    status: "",
  };

  const departmentNames = userProfileData?.departmentUsers?.map(
    (data: any) => data?.department?.name
  );

  // PATIENT  DATA
  const profileDetails = [
    {
      label: "First Name",
      value: userProfileData?.firstName || "-",
    },
    {
      label: "Last Name",
      value: userProfileData?.lastName || "-",
    },
    {
      label: "Email",
      value: userProfileData?.email,
    },
    {
      label: "Gender",
      value: userProfileData?.gender,
    },
    {
      label: "Role",
      // value: Userdata?.roleNames?.join(", ") || "-", // from login user data
      value: userProfileData?.role?.name || "-",
    },
    {
      label: "Phone",
      value: userProfileData?.contactNumber || "-",
    },
    // {
    //   label: "Provider Type",
    //   value: userProfileData?.type || "-",
    // },
    {
      label: "BSA ID",
      value: userProfileData?.bsaId || "-",
    },
    // {
    //   label: "Speciality",
    //   value: userProfileData?.specialities?.split(" ")?.join(", ") || "-",
    // },
    {
      label: "Department",
      value: departmentNames?.join(", ") || "-",
    },
    {
      label: "Facility Name",
      value: userProfileData?.facility?.name || "-",
    },
    {
      label: "Status",
      value: userProfileData?.status || "-",
    },
  ];

  const profileColumns = [
    {
      field: "taskType",
      label: <div>Task Type</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">
            <TooltipForTable label={row?.taskType} />
          </p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        const status = row?.status || "-";
        const showDot = status !== "-";
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.status),
                background: getStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              {showDot ? (
                <span
                  className="w-2 h-2"
                  style={{
                    background: getStatusDotColor(status),
                    borderRadius: "50%",
                  }}
                ></span>
              ) : null}
              {destructStatusData(status)}
            </span>
          </div>
        );
      },
    },
    {
      field: "assignedDate",
      label: <div>Assigned Date</div>,
      renderLogic: (row: any) => {
        const [date, time] = row?.assignedDate.split("\n");
        return (
          <p className="text-neutral-90 font-normal">
            {date} <br /> {time}
          </p>
        );
      },
    },
    {
      field: "dueDate",
      label: <div>Due Date</div>,
      renderLogic: (row: any) => {
        const [date, time] = row?.dueDate.split("\n");
        return (
          <p className="text-neutral-90 font-normal">
            {date} <br /> {time}
          </p>
        );
      },
    },

    // {
    //   field: "contactNumber",
    //   label: <div>Contact Number</div>,
    //   renderLogic: (row: any) => {
    //     return (
    //       <p className="text-neutral-90 font-normal">{row?.contactNumber}</p>
    //     );
    //   },
    // },
    // {
    //   field: "emergencyContact",
    //   label: <div>Emergency Contact</div>,
    //   renderLogic: (row: any) => {
    //     return (
    //       <p className="text-neutral-90 font-normal">{row?.emergencyContact}</p>
    //     );
    //   },
    // },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Tasks",
                    onClickCb: () => {
                      setSelectedTask(row);
                      setOpenViewTaskDialog(true);
                      //   navigate(`/patient/${row}`);
                    },
                  },
                  {
                    label: "Edit Task",
                    onClickCb: () => {
                      setDefaultTaskDataRow(row);
                      setOpenAddTaskDialog(true);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // PATIENT TAB ROW DATA
  const taskRowData = taskListData?.tasks?.map((data: any) => {
    return {
      taskType: data?.taskType || "",
      assignBy: `${data?.assigendBy?.firstName || "-"} ${data?.assigendBy?.lastName || ""}`,
      assignTo: `${data?.assigendTo?.firstName || "-"} ${data?.assigendTo?.lastName || ""}`,
      assignedDate: data?.assigenDate
        ? moment(data?.assigenDate).format("MM/DD/YYYY")
        : "-",
      dueDate: data?.dueDate
        ? moment.utc(data?.dueDate).format("MM/DD/YYYY")
        : "-",
      status:
        data?.status === "InProgress" ? "In Progress" : data?.status || " ",
      rowData: data,
    };
  });

  // CLOSE ADD TASK DIALOG
  useEffect(() => {
    if (closeEditTaskDialog) {
      setOpenAddTaskDialog(false);
      dispatch(setcloseEditTaskDialog(false));
    }
  }, [closeEditTaskDialog]);

  //USE EFFECT for GET API
  useEffect(() => {
    try {
      const payload = {
        assigenTo: loginUserId, // get the data as per the login user
        pageNumber: pageNumber,
        limit: rowPerPage,
        ...isPaginationApplied?.filterData,
      };
      dispatch(getProviderTaskList(payload));
    } catch (error) {}
  }, [
    closeEditTaskDialog,
    pageNumber,
    rowPerPage,
    isPaginationApplied?.filterData,
  ]);

  useEffect(() => {
    dispatch(getUserById(loginUserId));
  }, []);

  const handleEditTaskData = (formData: any) => {
    try {
      const payload = {
        status:
          formData?.status === "inProgress"
            ? "InProgress"
            : `${formData?.status.charAt(0).toUpperCase() + formData?.status.substring(1)}` ||
              undefined,
      };

      const taskId = defaultTaskDataRow?.rowData?.id;
      if (!taskId) {
        throw new Error("Task ID is required for updates.");
      }
      // Construct the update payload
      const taskUpdatePayload = {
        apiPayload: {
          ...payload,
        },
        taskId,
      };
      // Dispatch the update action
      dispatch(updateEditTaskData(taskUpdatePayload));
    } catch (error) {
      console.error("Error in handleUpdateTaskData:", error);
    }
  };

  // CLOSE USER PROFILE
  useEffect(() => {
    if (closeAddUserProfileDialog) {
      dispatch(getUserById(loginUserId));
      setIsEditable(false);
      dispatch(setCloseAddUserProfileDialog(false));
    }
  }, [closeAddUserProfileDialog]);

  // CLOSE CHANGE PASSWORD DIALOG -> force logout & redirect to login
  useEffect(() => {
    if (closeChangePasswordDialog) {
      setOpenChangePasswordDialog(false);
      dispatch(setCloseChangePasswordDialog(false));
      localStorage.clear();
      sessionStorage.clear();
      dispatch(setIsLoggedIn(false));
      window.location.href = "/login";
    }
  }, [closeChangePasswordDialog]);

  const handleChangePassword = (formData: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    dispatch(
      changePassword({
        oldPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        confirmNewPassword: formData.confirmPassword,
      })
    );
  };

  const handleEditProfileData = (data: any) => {
    try {
      const patchProfileDetailsPayload = {
        payload: {
          firstName: data?.patientFirstName,
          lastName: data?.patientLastName,
          gender: data?.gender,
          contactNumber: data?.patientNumber,
          // facilityId: "",
          // password: "",
          departmentIds: data?.department,
          // dateOfBirth: "",
          status: data?.status,
          // baseCamp: data?.baseCamp,
          // patientBSAId: data?.patientBSAId,
          // patientEmail: data?.patientEmail,
          // providerType: data?.providerType,
          // role: data?.role,
          // speciality: data?.speciality,
        },
        userId: loginUserId,
      };
      dispatch(updateProfileDetailsData(patchProfileDetailsPayload));
    } catch (error) {
      console.log("error:", error);
    }
  };
  return (
    <WrapperCard
      customClasses="m-3 p-3 pl-4 pr-4 flex-1 min-h-0 flex flex-col"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col flex-1 min-h-0 gap-3">
        {/*  SCREEN HEADER */}
        <div className={`flex items-center justify-between w-full`}>
          <Heading title="Setting" /> {/* EDIT ICON */}
          <div className="flex gap-2">
            <Button
              label="Change Password"
              variant="outlined"
              style={{
                padding: "5px 15px",
                background: "#FFFFFF",
                color: "#364144",
                border: "1px solid #D2D2D2",
                width: "max-content",
                visibility: !isEditable ? "visible" : "hidden",
              }}
              onClickCb={() => {
                setOpenChangePasswordDialog(true);
              }}
            />
            <Button
              startIcon={
                <img
                  src={editPencil}
                  alt={"search"}
                  className="cursor-pointer"
                />
              }
              label="Edit Profile"
              variant="outlined"
              style={{
                padding: "5px 15px",
                background: "#FFFFFF",
                color: "#364144",
                border: "1px solid #D2D2D2",
                width: "max-content",
                visibility: !isEditable ? "visible" : "hidden",
              }}
              onClickCb={() => {
                handleIsEdited();
                //   onEditClick && onEditClick();
              }}
            ></Button>
          </div>
        </div>
        {/* MAIN CONTENT */}
        <div
          style={{
            overflow: "auto",
            flex: "1 1 0%",
            minHeight: 0,
            paddingRight: hasOverflow ? "6px" : 0,
          }}
          ref={divRef}
        >
          {/* PROVIDER PROFILE DETAILS CARD */}
          <EventEHRProviderProfileDetailCardWithEdit
            patientDetails={profileDetails}
            defaultFieldsData={userProfileData}
            isEditable={isEditable}
            onEditClick={handleIsEdited}
            handleOnSubmittedData={(formData) => {
              handleEditProfileData(formData);
            }}
          />

          <div className="mt-4">
            <div className="pl-2 mb-3">
              <Heading
                title={roleName ? `${roleName} Task` : "Tasks"}
                customStyle={{ color: "#1D1D1D" }}
              />
            </div>

            <Table
              columns={profileColumns}
              rows={taskRowData}
              paginationProps={{
                isPagination: true,
                page: pageNumber,
                totalPages: taskListData?.totalPages,
                totalCount: taskListData?.totalRecords,
                limit: rowPerPage,
                rowsPerPageOptions: [10, 25, 50],
                onPageChange: (page: any) => {
                  setPageNumber(page);
                },
                handleChangeRowsPerPage: (rowPerPage: any) => {
                  setRowPerPage(rowPerPage);
                  setPageNumber(1);
                },
              }}
            />
          </div>
        </div>
      </div>

      {openAddTaskDialog && (
        <EditTaskDialog
          defaultTaskData={defaultTaskDataRow}
          dialogHeading={defaultTaskDataRow?.status ? "Edit Task" : "Add Task"}
          isOpen={openAddTaskDialog}
          handleClose={() => {
            setOpenAddTaskDialog(false);
          }}
          handleEditTaskData={(formData) => {
            handleEditTaskData(formData);
          }}
        />
      )}
      {openViewTaskDialog && (
        <ViewTaskDialog
          dialogHeading="View Task Details"
          isOpen={openViewTaskDialog}
          taskData={selectedTask || defaultTaskData}
          handleClose={() => {
            setOpenViewTaskDialog(false); // Close the dialog
          }}
        />
      )}
      {openChangePasswordDialog && (
        <ChangePasswordDialog
          isOpen={openChangePasswordDialog}
          handleClose={() => setOpenChangePasswordDialog(false)}
          handleChangePassword={handleChangePassword}
        />
      )}
    </WrapperCard>
  );
};

export default SettingsScreen;
